import React, { useState, useContext, useEffect, useMemo } from 'react';
import '../componentsCSS/StoryViewer.css' // Importer le CSS spécifique à ce composant
import { UserContext } from '../UserContext';

const StoryViewer = ({ slides, onClose, day, onPointsEarned }) => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedAnswer, setSelectedAnswer] = useState(null); // Suivi du bouton cliqué
  const [isCorrect, setIsCorrect] = useState(null); // Suivi si la réponse est correcte
  const [pointsEarned, setPointsEarned] = useState(0);
  const [needUpdate, setNeedUpdate] = useState(false);
  const { userData, setUserData } = useContext(UserContext);
  // const dayQuizzUserData = userData?.quizz_answers?.[`quizz${day}`] || [];
  const currentSlide = slides[currentIndex];
  const dayQuizzUserData = useMemo(() => {
    return userData?.quizz_answers?.[`quizz${day}`] || [];
  }, [userData, day]); 

  useEffect(() => {
    // Initialiser `selectedAnswer` et `isCorrect` à partir des réponses existantes
    const currentResponse = dayQuizzUserData[currentIndex-1];
    if (currentResponse !== undefined && currentResponse !== null) {
      setSelectedAnswer(currentResponse);
      const isCorrectNow = currentResponse === currentSlide.correctIndex;
      setIsCorrect(isCorrectNow);
    } else {
      setSelectedAnswer(null);
      setIsCorrect(null);
    }
  }, [currentIndex, dayQuizzUserData, currentSlide]);


  const handleNextSlide = (event) => {
    event.stopPropagation();
    // console.log("les réponses du jour", dayQuizzUserData)

    // const currentResponse = dayQuizzUserData?.[currentIndex] || null;
    // console.log("la réponse de la slide : ", currentResponse)
  
    // // Initialise `selectedAnswer` et `isCorrect` à partir de la réponse existante, si disponible
    // setSelectedAnswer(currentResponse);
    // console.log("normalement la réponse donnée est : ", currentResponse)
    // setIsCorrect(currentResponse === slides[currentIndex].correctIndex);
  
    if (currentIndex < slides.length - 1) {
      // setSelectedAnswer(null); // Réinitialise pour la prochaine question
      // setIsCorrect(null);
      setCurrentIndex((prevIndex) => prevIndex + 1);
    } else {
      // Dernière slide atteinte : fermer le StoryViewer et transmettre les données mises à jour
      onClose(dayQuizzUserData, needUpdate, day);
    }
  };


  const handleAnswerClick = (event, index) => {
    event.stopPropagation();

    console.log("la réponse déjà donné était ? ", selectedAnswer)
    // L'utilisateur n'avait pas encore répondu à cette question :
    if (selectedAnswer === null) {
      console.log("ici")
      const correctAnswerIndex = slides[currentIndex].correctIndex;
      const isCorrectNow = index === correctAnswerIndex;

      setSelectedAnswer(index);
      setIsCorrect(isCorrectNow);
      setNeedUpdate(true);

      if (isCorrectNow) {
        const points = currentSlide.points || 3; //
        setPointsEarned((prevPoints) => prevPoints + points); // Met à jour les points internes
        onPointsEarned(points); // Envoie les points à Calendar
        console.log("points gagnés : ", pointsEarned)
      }
      // Mise à jour des réponses du quiz
      const updatedDayQuizzUserData = [...dayQuizzUserData, index];
      userData.quizz_answers[`quizz${day}`] = updatedDayQuizzUserData;

      setUserData((prevUserData) => ({
        ...prevUserData,
        quizz_answers: {
          ...prevUserData.quizz_answers,
          [`quizz${day}`]: updatedDayQuizzUserData,
        },
      })); // Mettre à jour le contexte utilisateur
      console.log("Mise à jour des réponses : ", updatedDayQuizzUserData);
    }
  };

  return (
    <div className="story-viewer" onClick={() => onClose(dayQuizzUserData, needUpdate, day)}>
      
        <div 
            className="story-slide" 
            onClick={(event) => handleNextSlide(event)}
            style={{
                backgroundImage: `url(${currentSlide.image})`,
                backgroundSize: "cover",
            }}
        >

          {/* Bouton Fermer */}
          {currentIndex < slides.length - 1 && (
            <button
            className="close-button"
            onClick={(event) => handleNextSlide(event)}
          >
            Suivant
          </button>
          )}
          {currentIndex === slides.length - 1 && (
            <button
            className="close-button"
            onClick={(event) => {
              event.stopPropagation(); // Empêche de déclencher `handleNextSlide`
              onClose(dayQuizzUserData, needUpdate, day);
            }}
          >
            Fermer
          </button>
          )}


          {/* poll slide */}
        {currentSlide.type === "poll" && (
            <> 
            <div className="poll-question" style={{ whiteSpace: "pre-line" }}>
                {currentSlide.question}
            </div>
            <div className="poll-options">
              {currentSlide.options.map((option, index) => (
                <button 
                    key={index} 
                    onClick={(event) => handleAnswerClick(event, index)}
                    disabled={selectedAnswer !== null}
                    className={`poll-button poll-button${index}`}
                    style={{
                        backgroundColor:
                            selectedAnswer === null
                                ? "#ffffffd8" // Couleur par défaut
                                : index === currentSlide.correctIndex
                                ? "#7ED957" // Couleur pour la bonne réponse
                                : index === selectedAnswer
                                ? "#EF4647" // Couleur pour la mauvaise réponse
                                : "#ffffffd8", // Gris pour les autres réponses
                        border: 
                            selectedAnswer === null
                                ? "2px solid #68C2DB" // Couleur par défaut
                                : index === currentSlide.correctIndex
                                ? "2px solid #7ED957" // Couleur pour la bonne réponse
                                : index === selectedAnswer
                                ? "2px solid #EF4647" // Couleur pour la mauvaise réponse
                                : "2px solid #68C2DB", // Couleur pour les autres réponses
                        color: 
                            selectedAnswer === null
                                ? "#545454" // Couleur par défaut gris
                                : index === currentSlide.correctIndex
                                ? "#ffffff" // Couleur pour la bonne réponse
                                : index === selectedAnswer
                                ? "#ffffff" // Couleur pour la mauvaise réponse
                                : "#545454", // Gris pour les autres réponses
                        fontWeight: "bold",
                        fontFamily: "Arial, sans-serif", // Police personnalisée
                        // fontSize: "80%", // Taille du texte
                      }}
                >
                {option}
                {/* Affiche "+3" si c'est la bonne réponse */}
                {isCorrect && selectedAnswer === index && (
                <span className="points-animation">+{currentSlide.points}</span>
                )}
                </button>
              ))}
            </div>
            </>
        )}

          {currentSlide.type === "vrai-faux" && (
            <> 
            <div className="poll-question">
                {currentSlide.question}
            </div>
            <div className="poll-options">
              {currentSlide.options.map((option, index) => (
                <button 
                    key={index} 
                    onClick={(event) => handleAnswerClick(event, index)}
                    disabled={selectedAnswer !== null}
                    className={`vrai-faux-button vrai-faux-button${index}`}
                    style={{
                        backgroundColor:
                            selectedAnswer === null
                                ? "#ffffffd8" // Couleur par défaut
                                : index === currentSlide.correctIndex
                                ? "#7ED957" // Couleur pour la bonne réponse
                                : index === selectedAnswer
                                ? "#EF4647" // Couleur pour la mauvaise réponse
                                : "#ffffffd8", // Gris pour les autres réponses
                        border: 
                            selectedAnswer === null
                                ? "2px solid #68C2DB" // Couleur par défaut
                                : index === currentSlide.correctIndex
                                ? "2px solid #7ED957" // Couleur pour la bonne réponse
                                : index === selectedAnswer
                                ? "2px solid #EF4647" // Couleur pour la mauvaise réponse
                                : "2px solid #68C2DB", // Couleur pour les autres réponses
                        color: 
                            selectedAnswer === null
                                ? "#545454" // Couleur par défaut gris
                                : index === currentSlide.correctIndex
                                ? "#ffffff" // Couleur pour la bonne réponse
                                : index === selectedAnswer
                                ? "#ffffff" // Couleur pour la mauvaise réponse
                                : "#545454", // Gris pour les autres réponses
                        fontWeight: "bold",
                        fontFamily: "Arial, sans-serif", // Police personnalisée
                        // fontSize: "80%", // Taille du texte
                      }}
                >
                {option}
                {/* Affiche "+3" si c'est la bonne réponse */}
                {isCorrect && selectedAnswer === index && (
                <span className="points-animation">+{currentSlide.points}</span>
                )}
                </button>
              ))}
            </div>
            </>
        )}

          {/* Qui-est-ce slide */}
          {currentSlide.type === "qui-est-ce" && (
            <> 
            <div className="qui-est-ce-question">
                {currentSlide.question}
            </div>
            <div className="image-quiz-options">
              {currentSlide.options.map((option, index) => (
                <button
                key={index}
                className={`image-option ${
                  selectedAnswer !== null
                    ? index === currentSlide.correctIndex
                      ? "correct"
                      : index === selectedAnswer
                      ? "incorrect"
                      : ""
                    : ""
                }`}
                onClick={(event) => handleAnswerClick(event, index)}
                disabled={selectedAnswer !== null} // Désactive les clics après une sélection
              >
                <img
                  src={
                    selectedAnswer !== null
                      ? index === currentSlide.correctIndex
                        ? option.correctImage // Image pour la bonne réponse
                        : index === selectedAnswer
                        ? option.wrongImage // Image pour la mauvaise réponse
                        : option.defaultImage // Image par défaut pour les autres options
                      : option.defaultImage // Image par défaut si aucune réponse n'est sélectionnée
                  }
                  alt={`Option ${index + 1}`}
                />
              </button>
              ))}
            </div>
            </>
        )}

        {currentSlide.type === "video" && (
          <div className="video-container">
            <iframe
              width="100%"
              height="315"
              src={currentSlide.url}
              title="YouTube video player"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        )}

        {/* simple image slide */}
        {/* {currentSlide.type === "img" && (
        <img src={slides[currentIndex].image} alt={`Slide ${currentIndex + 1}`} />
        )} */}

        {currentSlide.type === "img_lien" && (
          <div className="img-lien-container">
            <div className="img-lien-wrapper"
            onClick={(e) => e.preventDefault()}>
              <a 
                href={slides[currentIndex].link} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="img-lien-link"
                onClick={(e) => e.stopPropagation()}
              >
                {slides[currentIndex].linkText || "En savoir plus"}
              </a>
            </div>
          </div>
        )}

        {/* Lien pour télécharger le PDF */}
        {currentSlide.type === "img_pdf" && (
        <div 
          className="pdf-link-wrapper" 
          onClick={(event) => event.stopPropagation()} // Empêche le clic sur l'image en arrière-plan
        >
          <a 
            href={slides[currentIndex].pdfUrl} 
            className="pdf-download-link"
            target="_blank" 
            rel="noopener noreferrer"
          >
            {slides[currentIndex].linkText || "Télécharger le PDF"}
          </a>
        </div>
        )}
      </div>
    </div>
  );
};

export default StoryViewer;